import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { 
  LayoutDashboard, 
  Users, 
  MessageSquare, 
  Package, 
  FileText,
} from 'lucide-react';

const menuItems = [
  { 
    path: '/admin-web/dashboard', 
    label: 'Dashboard', 
    icon: LayoutDashboard 
  },
  { 
    path: '/admin-web/users', 
    label: 'Users', 
    icon: Users 
  },
  { 
    path: '/admin-web/reviews', 
    label: 'Reviews Moderation', 
    icon: MessageSquare 
  },
  { 
    path: '/admin-web/products', 
    label: 'Products', 
    icon: Package 
  },
  { 
    path: '/admin-web/blog', 
    label: 'Blog', 
    icon: FileText 
  }
];

type AdminNavigationProps = {
  collapsed: boolean;
};

export const AdminNavigation = ({ collapsed }: AdminNavigationProps) => {
  const location = useLocation();

  return (
    <nav className="p-2 flex-1">
      {menuItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={cn(
            "flex items-center gap-2 px-4 py-2 rounded-lg mb-1 transition-colors",
            location.pathname === item.path 
              ? "bg-primary text-primary-foreground" 
              : "hover:bg-gray-100"
          )}
        >
          <item.icon className="h-5 w-5" />
          {!collapsed && <span>{item.label}</span>}
        </Link>
      ))}
    </nav>
  );
};